/**
 * Created by neo on 11.01.21.
 */
import { makeAutoObservable } from 'mobx';
import { ExploreEntry, createExploreEntry } from './ExploreEntry';
import { HttpBackend } from '../../Services/Http/HttpBackend';
import { v1ParamsToV3Params } from './exploreV3Params';
import { ExploreEntryQueryRequest } from './ExploreEntryQueryRequest';
import { LocalizedValue, createLocalizedValue } from '../LocalizedValue';
import { NativeFeedComponent, createNativeFeedComponent } from '../Feed/GetStream/NativeFeedComponent';

export type ArticleEntry = ExploreEntry & {
  type: 'article';
  content: NativeFeedComponent[];
  preview?: LocalizedValue[];
  readTimeInMinutes: number;
  getPreview(lang: string): string | undefined;
};

export function createArticleEntry(json?: Partial<ArticleEntry>): ArticleEntry {
  const base = createExploreEntry({ ...json, type: 'article' });
  return makeAutoObservable({
    ...base,
    type: 'article' as const,
    content: (json?.content ?? []).map((c: any) => createNativeFeedComponent(c)),
    preview: (json?.preview ?? []).map((c: any) => createLocalizedValue(c)),
    readTimeInMinutes: json?.readTimeInMinutes ?? 0,

    getPreview(lang: string): string | undefined {
      return this.preview?.find((n) => n.lang === lang.toLowerCase())?.value || undefined;
    },
  });
}

export const ArticleEntryApi = {
  find(request: Omit<ExploreEntryQueryRequest, 'type'>): Promise<ArticleEntry[]> {
    return HttpBackend.get(`/coach/explore/v3/entries`, v1ParamsToV3Params({ ...request, type: 'article' })).then((res) =>
      (res ?? []).map((r: any) => createArticleEntry(r)),
    );
  },

  findOne(id: string): Promise<ArticleEntry> {
    return HttpBackend.get(`/coach/explore/v3/entries/${id}`).then((res) => createArticleEntry(res));
  },
};
